import Loading from '@/component/mui/Backdrop';
import { CreatePointSettingType } from '@/types';
import { Box, Button } from '@mui/material';
import { useState, MouseEvent } from 'react';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import PointSettingForm from '@/component/point/point-setting/Form';
import { pointSettings } from '@/api/point/create';

export default function PointSetting() {
  const [isLoading, setIsLoading] = useState(false);
  const [settings, setSettings] = useState<CreatePointSettingType>({
    season: 0,
    amount: '',
    totUserJoin: 0,
    referralReceivedMax: 0,
    referralReceived: '',
    referralJoin: '',
    dayParticipationCnt: 1,
    status: 0,
    code: '',
  });
  const navigate = useNavigate();

  const onSubmit = async (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    setIsLoading(true);
    // 풀이름 추가, 설명 추가, 최소스테이킹 금액(달러), 이자율, 모금 기간, 운영기간, 최소최대 함수 호출
    await handleContract();
  };
  const handleContract = async () => {
    try {
      // await createPool(pools);
      await pointSettings(settings);
      toast.success('성공');
      setTimeout(() => {
        navigate('/point-setting-list');
      }, 2000);
    } catch (e) {
      console.log(e);
      toast.success('실패');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          overflow: 'auto',
          flex: 1,
          flexDirection: 'column',
          gap: { xs: '16px', sm: '0px' },
          padding: 2,
        }}
      >
        <PointSettingForm settings={settings} setSettings={setSettings} />
        <Button variant="contained" onClick={onSubmit}>
          Create
        </Button>
      </Box>
      <Loading isLoading={isLoading} />
    </>
  );
}
